import React, { memo, ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import { StreamContent } from '..'
import { TestID } from '../../../utils/PropTypesDefinitions'
import { ratios } from '../../../utils/ImageHelper'

export interface StreamTeaserV2Props extends TestID {
    /** defines the label which is shown and the text color of the crawling text
     *
     * live: Label -> "Live" | TextColor -> pearl
     *
     * breaking: Label -> "Breaking" | TextColor -> ORANGE
     * */
    labelType: 'live' | 'breaking'
    /** the width of the container in which the stream or the fallback image are shown */
    width: number
    /** the ratio of the stream */
    ratio: number
    /** the text of the crawl */
    headlineText?: string
    /** the fallback image if autoplay is false or no renderStream function was provided */
    mainImageUrl?: string
    /** boolean to determine if autoplay is on or off */
    autoplay: boolean
    /** function which should return the stream
     *
     * @TJS-type function
     * */
    renderStream?: () => ReactElement
    /** callback when the user pressed on the autoplay icon
     *
     * @TJS-type function
     * */
    onPressAutoPlay: (autoplay: boolean) => void
    /** callback when the user pressed on the stream teaser
     *
     * @TJS-type function
     * */
    onPress?: () => void
    /**
     * is used to render with different height
     *
     * @defaultValue 343:272
     */
    cardRatio?: '343:272' | '3:2'
}

const StreamTeaserV2 = ({
    labelType,
    width,
    ratio,
    headlineText,
    mainImageUrl,
    renderStream,
    autoplay,
    onPressAutoPlay,
    onPress,
    cardRatio = '343:272',
    testID,
}: StreamTeaserV2Props): ReactElement => {
    const contentWidth = width - 31
    const contentHeight = contentWidth / ratio
    const cardHeight = contentWidth / ratios('none', cardRatio)
    return (
        <Grid borderRadius={5} marginX={5} overflow="hidden" height={cardHeight} noExpand>
            <Touchable onPress={onPress} testID={testID}>
                <StreamContent
                    labelType={labelType}
                    contentHeight={contentHeight}
                    autoplay={autoplay}
                    onPressAutoPlay={onPressAutoPlay}
                    headlineText={headlineText}
                    mainImageUrl={mainImageUrl}
                    renderStream={renderStream}
                />
            </Touchable>
            <Grid backgroundColor="onyx" />
        </Grid>
    )
}

export default memo(StreamTeaserV2)
